module.exports = {versao:
62
, alt:false, app:"Aplicativo GO"
, base:"http://www.aplicativogo.com.br"
, url:"https://sec-api.aplicativogo.com.br"};
